/**
 * @desc 创建MSKU和FNSKU
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.CrateMskuMapAndFnskuRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/msku/crateMskuMapAndFnskuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
